var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import KYCConfirmMitekModal from './KYCConfirmMitekModalComponent';
import APIFrame from '../../common/APIFrame/APIFrame';
import Spinner from '../../common/Spinner/Spinner';
import path from '../../../helpers/path';
import { kycConfigLevelShape } from '../../../propTypes/kycConfigShapePropTypes';
var KYCMitekComponent = function (_React$Component) {
  _inherits(KYCMitekComponent, _React$Component);
  function KYCMitekComponent(props) {
    _classCallCheck(this, KYCMitekComponent);
    var _this = _possibleConstructorReturn(this, (KYCMitekComponent.__proto__ || Object.getPrototypeOf(KYCMitekComponent)).call(this, props));
    _this.confirmInfoMitek = function () {
      var _this$props = _this.props,
        alphaPointUserID = _this$props.alphaPointUserID,
        userName = _this$props.userName,
        confirmInfoMitek = _this$props.confirmInfoMitek;
      var confirmInfoMitekPayload = {
        UserId: Number(alphaPointUserID),
        UserName: userName
      };
      confirmInfoMitek(confirmInfoMitekPayload);
    };
    _this.openModal = function (isOpen) {
      return _this.setState({
        isOpen: isOpen
      });
    };
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _createClass(KYCMitekComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
        alphaPointUserID = _props.alphaPointUserID,
        alphaPointSessiontoken = _props.alphaPointSessiontoken,
        _props$kycConfig = _props.kycConfig,
        type = _props$kycConfig.type,
        requestIdentifier = _props$kycConfig.requestIdentifier,
        launchMitek = _props.launchMitek,
        userConfig = _props.userConfig;
      var config = userConfig.reduce(function (item, i) {
        item[i.Key] = i.Value;
        return item;
      }, {});
      var userInfo = {
        firstName: config.fname,
        middleName: config.middleName,
        lastName: config.lname,
        dob: config.dob,
        email: config.email,
        billingStreetAddress: config.billingStreetAddress,
        billingCountry: config.billingCountry,
        billingCity: config.billingCity,
        billingState: config.billingState,
        billingZip: config.billingZip,
        phone: config.telephone,
        state: config.billingState,
        billingStreetNumber: config.billingStreetNumber,
        billingStreetType: config.billingStreetType,
        billingSuburb: config.billingCity,
        accountName: alphaPointUserID,
        billingFlatNumber: '',
        salutation: ''
      };
      var clientInfo = {
        alphaPointSessiontoken: alphaPointSessiontoken,
        alphaPointUserID: alphaPointUserID,
        validationStage: 2,
        validator: type
      };
      launchMitek({
        requestIdentifier: requestIdentifier,
        clientInfo: clientInfo,
        userInfo: userInfo
      }, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props2 = this.props,
        kyc = _props2.kyc,
        processing = _props2.processing;
      return React.createElement(React.Fragment, null, React.createElement(Spinner, {
        isVisible: processing
      }), !processing && React.createElement(APIFrame, {
        id: 'mitek-iframe',
        src: path('/mitek.html' + kyc.urlParams),
        customClass: 'mitek',
        onLoad: function onLoad() {
          var iframe = document.getElementById('mitek-iframe');
          var that = _this2;
          iframe.contentWindow.document.addEventListener('idchecker-finish', function () {
            iframe.contentWindow.document.querySelector('[ng-show="vm.success"]').innerHTML = ' ';
            that.openModal(true);
          }, false);
        }
      }), React.createElement(KYCConfirmMitekModal, {
        isOpen: this.state.isOpen,
        close: function close() {
          return _this2.confirmInfoMitek();
        },
        onConfirm: function onConfirm() {
          return _this2.confirmInfoMitek();
        }
      }));
    }
  }]);
  return KYCMitekComponent;
}(React.Component);
export default KYCMitekComponent;
KYCMitekComponent.propTypes = {
  kycConfig: PropTypes.shape({
    type: PropTypes.string,
    levels: PropTypes.arrayOf(PropTypes.shape(kycConfigLevelShape))
  })
};
KYCMitekComponent.contextTypes = {
  t: PropTypes.func.isRequired
};